import React, { useEffect, useState } from 'react'
import Chart from 'react-google-charts';
import { GroupByForeignKey } from '../../Actions/GetContainer';
import { Agrupar } from './Agrupar';

export const Sucursal = ({ data, encabezado }) => {
    const [state, setState] = useState([])
    const [grafica, setGrafica] = useState([]);
    const [adractivo, setAdrActivo] = useState('')
    useEffect(() => {
        var array = Agrupar(data, 'sucursal');
        setState(array);
        setAdrActivo(array[0]);

    }, [data]);
    useEffect(() => {
        var array = [encabezado];

        var sucursales = GroupByForeignKey(data, 'sucursal', adractivo, ['concepto'])


        sucursales.forEach((item, index) => {
            var obj = {
                invactual: 0,
                invanterior: 0
            }
            data.forEach(elements => {

                if (elements.concepto === item.concepto && elements.sucursal === adractivo) {
                    obj.invactual += elements.invactual;
                    obj.invanterior += elements.invanterior;
                }
            })
            array = [...array, [
                item.concepto
                , obj.invactual
                , obj.invanterior
            ]]
        })
        setGrafica(array);
    }, [adractivo])

    const colorBars = [
        "rgb(79,123,88)",
        "rgb(155,176,111)"
    ];
    const changesucursal = (item) => {
        setAdrActivo(item)
        var element = document.getElementById('grafica-opciones');
        if (element !== undefined && element !== null) {
            if (element.childElementCount > 0) {
                var childs = element.childElementCount - 1;
                for (let i = 0; i <= childs; i++) {
                    var child = element.children[i];
                    if (child.id === `gri-${item}`)
                        child.className = 'opcion active';
                    else
                        child.className = 'opcion';
                }
            }
        }
    }

    return (
        <div className='grafica'>
            <div id='grafica-opciones' className='opciones'>
                {
                    state.map((item, index) => (
                        <div id={`gri-${item}`} className={`opcion ${index === 0 ? ' active' : ''}`}
                            onClick={() => changesucursal(item)}>
                            {item}</div>
                    ))
                }
            </div>
            <div>
                <Chart
                    chartType='ColumnChart'
                    loader={<div>Cargando Grafica</div>}
                    width='100%'
                    height='300PX'
                    data={grafica}
                    options={{
                        animation: { animation: 0 },
                        colors: colorBars,
                        intervals: { style: 'sticks' },
                       
                    }}
                />
            </div>
        </div>
    )
}
